import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { QuotesProvider } from "./context/QuotesContext";
import { TranslationProvider } from "./context/TranslationContext";
import LandingPage from "./pages/LandingPage";
import ConfiguratorSelection from "./pages/ConfiguratorSelection";
import PricingPage from "./pages/PricingPage";
import Configurator from "./pages/Configurator";
import Terrasdeur from "./pages/Terrasdeur";
import Achterdeur from "./pages/Achterdeur";
import Voordeur from "./pages/Voordeur";
import Schuifpui from "./pages/Schuifpui";
import Keralit from "./pages/Keralit";

function AppContent() {
  const location = useLocation();
  
  // Force remount of Routes when location changes
  // Use location.key for better remounting (React Router v6 provides unique keys)
  return (
    <TranslationProvider>
      <QuotesProvider>
        <div className="App" key={location.pathname}>
          <Routes key={location.key || location.pathname}>
            <Route path="/" element={<LandingPage key={location.pathname} />} />
            <Route path="/configurator-select" element={<ConfiguratorSelection key={location.pathname} />} />
            <Route path="/pricing" element={<PricingPage key={location.pathname} />} />
            <Route path="/kozijnen" element={<Configurator key={location.pathname} />} />
            <Route path="/terrasdeur" element={<Terrasdeur key={location.pathname} />} />
            <Route path="/achterdeur" element={<Achterdeur key={location.pathname} />} />
            <Route path="/voordeur" element={<Voordeur key={`voordeur-${location.pathname}`} />} />
            <Route path="/schuifpui" element={<Schuifpui key={`schuifpui-${location.pathname}`} />} />
            <Route path="/keralit" element={<Keralit key={location.pathname} />} />
          </Routes>
        </div>
      </QuotesProvider>
    </TranslationProvider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppContent />
    </BrowserRouter>
  );
}

export default App;
